export default __webpack_public_path__ + "15d25278fe76a075875676ac102f5d8f.png";